import axios from "axios";
import isDev from "server.js";
import { message } from "antd";

const serverUrl = isDev();

const apiCaller = ({
	apiLink,
	requestData,
	res200Callback,
	resCallback,
	resErrorCallback,
	bodyType,
	resFinalCallback,
}) => {
	const country = JSON.parse(localStorage.getItem("countryData"));
	// const address = require('address');
	// address((err, addrs) => {
	// 	console.log(addrs.ip, addrs.ipv6, addrs.mac);
	// 	// '192.168.0.2', 'fe80::7aca:39ff:feb0:e67d', '78:ca:39:b0:e6:7d'
	//   });
	axios
		.post(
			`${serverUrl}/${requestData?.countryId || country?.database_identifier || "uae"}/${apiLink}/`,
			requestData,
			{
				headers: {
					// "Content-Type": bodyType !== "formData" ? "application/json" : "multipart/form-data; boundary=----WebKitFormBoundaryaG0oBijcvWqsy2H",
					// "Content-Type":"application/json",
					Authorization: `JWT ${localStorage.getItem("token")}`,
				},
			}
		)
		.then((res) => {
			// console.log("Response :- " + JSON.stringify(res))
			if (resCallback) resCallback();
			if (resFinalCallback) resFinalCallback();
			if (res.data.status === 202 || res.status === 202) {
				message.info("Report download request is currently being processed. Please try again later.");
			} else if (res.data.status === 201 || res.status === 201) {
				message.success(res.data.message);
			} else if (res.data.status === 200) {
				if (res200Callback) res200Callback(res);
			} else {
				if (resErrorCallback) resErrorCallback(res);
				else message.error("Something went wrong!");
			}
		})
		.catch((err, res) => {
			if (resFinalCallback) resFinalCallback();
			if (err?.response?.data) {
				(err?.response?.data?.status / 100) > 4 ? message.error(err.response.data.message) : message.warning(err.response.data.message);
			} else {
				message.error("Something went wrong!");
			}
		});
};

export const fetchInaamActivityAnalyticsApi = ({ requestData, res200Callback, resCallback }) => {
	apiCaller({
		apiLink: "dashboard/fetch-reward-activity-analytics",
		requestData: { ...requestData, permission_category: ["ANALYTICS"] },
		res200Callback,
		resCallback,
	});
};
export const FetchTodaysActivity = ({ requestData, res200Callback, resCallback }) => {
	apiCaller({
		apiLink: "dashboard/fetch-todays-activity",
		requestData: { ...requestData, permission_category: ["ANALYTICS"] },
		res200Callback,
		resCallback,
	});
};
export const FetchFilteredActivity = ({ requestData, res200Callback, resCallback }) => {
	apiCaller({
		apiLink: "dashboard/fetch-filtered-activity",
		requestData: { ...requestData, permission_category: ["ANALYTICS"] },
		res200Callback,
		resCallback,
	});
};

export const fetchInaamCustomerListApi = ({ requestData, res200Callback, resCallback }) => {
	apiCaller({
		apiLink: "dashboard/fetch-reward-customer-list",
		requestData: { ...requestData, permission_category: ["ANALYTICS"] },
		res200Callback,
		resCallback,
	});
};
export const FetchDeviceAnalytics = ({ requestData, res200Callback, resCallback }) => {
	apiCaller({
		apiLink: "dashboard/fetch-device-analytics",
		requestData: { ...requestData, permission_category: ["ANALYTICS"] },
		res200Callback,
		resCallback,
	});
};
export const FetchLoginActivity = ({ requestData, res200Callback, resCallback }) => {
	apiCaller({
		apiLink: "dashboard/fetch-login-activity",
		requestData: { ...requestData, permission_category: ["ANALYTICS"] },
		res200Callback,
		resCallback,
	});
};
export const FetchReleaseAnalytics = ({ requestData, res200Callback, resCallback }) => {
	apiCaller({
		apiLink: "dashboard/fetch-release-analytics",
		requestData: { ...requestData, permission_category: ["ANALYTICS"] },
		res200Callback,
		resCallback,
	});
};

export const exportInaamCustomerApi = ({ requestData, res200Callback, resCallback }) => {
	apiCaller({
		apiLink: "dashboard/export-reward-customer-list",
		requestData: { ...requestData, permission_category: ["ANALYTICS"] },
		res200Callback,
		resCallback,
	});
};

export const createNotificationApi = ({ requestData, res200Callback, resCallback }) => {
	apiCaller({
		apiLink: "notification/create-notification",
		requestData: { ...requestData, permission_category: ["STORE_CONTROL_CENTER"] },
		res200Callback,
		resCallback,
	});
};

export const updateNotificationApi = ({ requestData, res200Callback, resCallback }) => {
	apiCaller({
		apiLink: "notification/update-notification",
		requestData: { ...requestData, permission_category: ["STORE_CONTROL_CENTER"] },
		res200Callback,
		resCallback,
	});
};

export const fetchNotificationListApi = ({ requestData, res200Callback, resCallback }) => {
	apiCaller({
		apiLink: "notification/fetch-notification-list",
		requestData: { ...requestData, permission_category: ["STORE_CONTROL_CENTER"] },
		res200Callback,
		resCallback,
	});
};

export const deleteNotificationApi = ({ requestData, res200Callback, resCallback }) => {
	apiCaller({
		apiLink: "notification/delete-notification",
		requestData: { ...requestData, permission_category: ["STORE_CONTROL_CENTER"] },
		res200Callback,
		resCallback,
	});
};

// export const fetchCohortListApi = ({ requestData, res200Callback, resCallback }) => {
// 	apiCaller({
// 		apiLink: "cohort/fetch-cohort-admin-list",
// 		requestData:{...requestData,permission_category:["ANALYTICS"]},
// 		res200Callback,
// 		resCallback,
// 	});
// };

export const exportCohortApi = ({ requestData, res200Callback, resCallback }) => {
	apiCaller({
		apiLink: "cohort/export-cohort",
		requestData: { ...requestData, permission_category: ["STORE_CONTROL_CENTER"] },
		res200Callback,
		resCallback,
	});
};

export const fetchPromotionListApi = ({ requestData, res200Callback, resCallback }) => {
	apiCaller({
		apiLink: "notification/fetch-all-promotion-list",
		requestData: { ...requestData, permission_category: ["STORE_CONTROL_CENTER"] },
		res200Callback,
		resCallback,
	});
};

export const fetchFlyerListApi = ({ requestData, res200Callback, resCallback }) => {
	apiCaller({
		apiLink: "notification/fetch-all-flyer-list",
		requestData: { ...requestData, permission_category: ["STORE_CONTROL_CENTER"] },
		res200Callback,
		resCallback,
	});
};

export const fetchInaamCardLinkRequestListApi = function ({ requestData, res200Callback, resCallback }) {
	apiCaller({
		apiLink: "card-link-request/fetch-reward-card-link-request-list",
		requestData,
		res200Callback,
		resCallback,
	});
};

export const fetchInaamCardLinkRequestCountApi = function ({ requestData, res200Callback, resCallback }) {
	apiCaller({
		apiLink: "card-link-request/fetch-reward-card-link-request-count",
		requestData,
		res200Callback,
		resCallback,
	});
};

export const resolveInaamCardLinkRequestApi = function ({ requestData, res200Callback, resCallback }) {
	apiCaller({
		apiLink: "card-link-request/resolve-reward-card-link-request",
		requestData,
		res200Callback,
		resCallback,
	});
};

export const verifyInaamCardLinkRequestApi = ({ requestData, res200Callback, resCallback }) => {
	apiCaller({
		apiLink: "card-link-request/verify-reward-card-link-request",
		requestData,
		res200Callback,
		resCallback,
	});
};

export const deleteInaamCardLinkRequestApi = function ({ requestData, res200Callback, resCallback }) {
	apiCaller({
		apiLink: "card-link-request/delete-reward-card-link-request",
		requestData,
		res200Callback,
		resCallback,
	});
};

export const exportCardLinkRequestsApi = function ({ requestData, res200Callback, resCallback }) {
	apiCaller({
		apiLink: "card-link-request/export-card-link-requests",
		requestData,
		res200Callback,
		resCallback,
	});
};

export const fetchInaamCustomerComplaintListApi = function ({ requestData, res200Callback, resCallback }) {
	apiCaller({
		apiLink: "customer-complaint/fetch-customer-complaint-list",
		requestData: { ...requestData, permission_category: ["CUSTOMER_SUPPORT"] },
		res200Callback,
		resCallback,
	});
};

export const fetchInaamCustomerComplaintCountApi = function ({ requestData, res200Callback, resCallback }) {
	apiCaller({
		apiLink: "customer-complaint/fetch-customer-complaint-count",
		requestData: { ...requestData, permission_category: ["CUSTOMER_SUPPORT"] },
		res200Callback,
		resCallback,
	});
};

export const resolveInaamCustomerComplaintsApi = function ({ requestData, res200Callback, resCallback }) {
	apiCaller({
		apiLink: "customer-complaint/resolve-customer-complaint",
		requestData: { ...requestData, permission_category: ["CUSTOMER_SUPPORT"] },
		res200Callback,
		resCallback,
	});
};

export const deleteInaamCustomerComplaintsApi = function ({ requestData, res200Callback, resCallback }) {
	apiCaller({
		apiLink: "customer-complaint/delete-customer-complaint",
		requestData: { ...requestData, permission_category: ["CUSTOMER_SUPPORT"] },
		res200Callback,
		resCallback,
	});
};

export const exportCustomerComplaintsApi = function ({ requestData, res200Callback, resCallback }) {
	apiCaller({
		apiLink: "customer-complaint/export-customer-complaint-report",
		requestData: { ...requestData, permission_category: ["CUSTOMER_SUPPORT"] },
		res200Callback,
		resCallback,
	});
};

export const fetchmailreplies = function ({ requestData, res200Callback, resCallback, resErrorCallback }) {
	apiCaller({
		apiLink: "customer-complaint/fetch-email-replies",
		requestData: { ...requestData, permission_category: ["CUSTOMER_SUPPORT"] },
		res200Callback,
		resCallback,
		resErrorCallback,
	});
};
export const replycustomercomplains = function ({ requestData, res200Callback, resCallback, resErrorCallback, bodyType, resFinalCallback }) {
	let x = Object.fromEntries(requestData)
	apiCaller({
		apiLink: "customer-complaint/reply-customer-complaint",
		// bodyType,
		requestData,
		res200Callback,
		resCallback,
		resErrorCallback,
		resFinalCallback
	});
};

export const fetchReportListApi = function ({ requestData, res200Callback, resCallback }) {
	apiCaller({
		apiLink: "report/fetch-report-list",
		requestData: { ...requestData, permission_category: ["REPORTS"] },
		res200Callback,
		resCallback,
	});
};
export const ExportRequestedReportApi = function ({ requestData, res200Callback, resCallback }) {
	apiCaller({
		apiLink: "report/export-requested-report",
		requestData: { ...requestData, permission_category: ["REPORTS"] },
		res200Callback,
		resCallback,
	});
};


export const deleteReportListApi = function ({ requestData, res200Callback, resCallback, resErrorCallback }) {
	apiCaller({
		apiLink: "report/delete-report-list",
		requestData: { ...requestData, permission_category: ["REPORTS"] },
		res200Callback,
		resCallback,
		resErrorCallback,
	});
};

export const fetchSurveyListApi = function ({ requestData, res200Callback, resCallback, resErrorCallback }) {
	apiCaller({
		apiLink: "survey/fetch-survey-list",
		requestData: { ...requestData, permission_category: ["REPORTS"] },
		res200Callback,
		resCallback,
		resErrorCallback,
	});
};//

export const saveSurveyApi = function ({ requestData, res200Callback, resCallback, resErrorCallback }) {
	apiCaller({
		apiLink: "survey/save-survey",
		requestData: { ...requestData, permission_category: ["REPORTS"] },
		res200Callback,
		resCallback,
		resErrorCallback,
	});
};

export const fetchSurveyDetailsApi = function ({ requestData, res200Callback, resCallback, resErrorCallback }) {
	apiCaller({
		apiLink: "survey/fetch-survey-details",
		requestData: { ...requestData, permission_category: ["REPORTS"] },
		res200Callback,
		resCallback,
		resErrorCallback,
	});
};//

export const fetchSurveyArchiveCountApi = function ({ requestData, res200Callback, resCallback, resErrorCallback }) {
	apiCaller({
		apiLink: "survey/fetch-survey-archive-count",
		requestData: { ...requestData, permission_category: ["REPORTS"] },
		res200Callback,
		resCallback,
		resErrorCallback,
	});
};//

export const fetchSurveyResponseCountApi = function ({ requestData, res200Callback, resCallback, resErrorCallback }) {
	apiCaller({
		apiLink: "survey/fetch-survey-response-count",
		requestData: { ...requestData, permission_category: ["REPORTS"] },
		res200Callback,
		resCallback,
		resErrorCallback,
	});
};//

export const archiveSurveyApi = function ({ requestData, res200Callback, resCallback, resErrorCallback }) {
	apiCaller({
		apiLink: "survey/archive-survey",
		requestData: { ...requestData, permission_category: ["REPORTS"] },
		res200Callback,
		resCallback,
		resErrorCallback,
	});
};//

export const publishSurveyApi = function ({ requestData, res200Callback, resCallback, resErrorCallback }) {
	apiCaller({
		apiLink: "survey/publish-survey",
		requestData: { ...requestData, permission_category: ["REPORTS"] },
		res200Callback,
		resCallback,
		resErrorCallback,
	});
};//

export const deleteSurveyApi = function ({ requestData, res200Callback, resCallback, resErrorCallback }) {
	apiCaller({
		apiLink: "survey/delete-survey",
		requestData: { ...requestData, permission_category: ["REPORTS"] },
		res200Callback,
		resCallback,
		resErrorCallback,
	});
};//

export const fetchSurveyAnalyticsApi = function ({ requestData, res200Callback, resCallback, resErrorCallback }) {
	apiCaller({
		apiLink: "survey/survey-analytics",
		requestData: { ...requestData, permission_category: ["REPORTS"] },
		res200Callback,
		resCallback,
		resErrorCallback,
	});
};//

export const fetchSurveyResponseListApi = function ({ requestData, res200Callback, resCallback, resErrorCallback }) {
	apiCaller({
		apiLink: "survey/fetch-survey-response-list",
		requestData: { ...requestData, permission_category: ["REPORTS"] },
		res200Callback,
		resCallback,
		resErrorCallback,
	});
};//

export const fetchSurveyResponseDetailApi = function ({ requestData, res200Callback, resCallback, resErrorCallback }) {
	apiCaller({
		apiLink: "survey/fetch-survey-response-details",
		requestData: { ...requestData, permission_category: ["REPORTS"] },
		res200Callback,
		resCallback,
		resErrorCallback,
	});
};//

export const fetchCohortAdminListApi = function ({ requestData, res200Callback, resCallback, resErrorCallback }) {
	apiCaller({
		apiLink: "cohort/fetch-cohort-admin-list",
		requestData: { ...requestData, permission_category: ["STORE_CONTROL_CENTER", "REPORTS"] },
		res200Callback,
		resCallback,
		resErrorCallback,
	});
};

export const fetchCohortDetailApi = function ({ requestData, res200Callback, resCallback, resErrorCallback }) {
	apiCaller({
		apiLink: "cohort/fetch-cohort-details",
		requestData: { ...requestData, permission_category: ["STORE_CONTROL_CENTER"] },
		res200Callback,
		resCallback,
		resErrorCallback,
	});
};

export const createCohortApi = function ({ requestData, res200Callback, resCallback, resErrorCallback }) {
	apiCaller({
		apiLink: "cohort/create-cohort",
		requestData: { ...requestData, permission_category: ["STORE_CONTROL_CENTER"] },
		res200Callback,
		resCallback,
		resErrorCallback,
	});
};

export const importCohortApi = function ({ requestData, res200Callback, resCallback, resErrorCallback }) {
	apiCaller({
		apiLink: "cohort/import-cohort",
		requestData: { ...requestData, permission_category: ["STORE_CONTROL_CENTER"] },
		res200Callback,
		resCallback,
		resErrorCallback,
	});
};

export const archiveCohortApi = function ({ requestData, res200Callback, resCallback, resErrorCallback }) {
	apiCaller({
		apiLink: "cohort/archive-cohort",
		requestData: { ...requestData, permission_category: ["STORE_CONTROL_CENTER"] },
		res200Callback,
		resCallback,
		resErrorCallback,
	});
};

export const deleteCohortApi = function ({ requestData, res200Callback, resCallback, resErrorCallback }) {
	apiCaller({
		apiLink: "cohort/delete-cohort",
		requestData: { ...requestData, permission_category: ["STORE_CONTROL_CENTER"] },
		res200Callback,
		resCallback,
		resErrorCallback,
	});
};

export const updateCohortNameApi = function ({ requestData, res200Callback, resCallback, resErrorCallback }) {
	apiCaller({
		apiLink: "cohort/update-cohort",
		requestData: { ...requestData, permission_category: ["STORE_CONTROL_CENTER"] },
		res200Callback,
		resCallback,
		resErrorCallback,
	});
};

export const fetchCohortCountApi = function ({ requestData, res200Callback, resCallback, resErrorCallback }) {
	apiCaller({
		apiLink: "cohort/fetch-cohort-count",
		requestData: { ...requestData, permission_category: ["STORE_CONTROL_CENTER"] },
		res200Callback,
		resCallback,
		resErrorCallback,
	});
};

export const updateCohortApi = function ({ requestData, res200Callback, resCallback, resErrorCallback }) {
	apiCaller({
		apiLink: "cohort/update-cohort-customer-list",
		requestData: { ...requestData, permission_category: ["STORE_CONTROL_CENTER"] },
		res200Callback,
		resCallback,
		resErrorCallback,
	});
};

export const searchCohortApi = function ({ requestData, res200Callback, resCallback, resErrorCallback }) {
	apiCaller({
		apiLink: "cohort/search-cohort-customer-list",
		requestData: { ...requestData, permission_category: ["STORE_CONTROL_CENTER"] },
		res200Callback,
		resCallback,
		resErrorCallback,
	});
};

export const searchCustomersApi = function ({ requestData, res200Callback, resCallback, resErrorCallback }) {
	apiCaller({
		apiLink: "search-customers",
		requestData,
		res200Callback,
		resCallback,
		resErrorCallback,
	});
};

export const fetchLscCustomer = function ({ requestData, res200Callback, resCallback, resErrorCallback }) {
	apiCaller({
		apiLink: "fetch-lsc-customer",
		requestData,
		res200Callback,
		resCallback,
		resErrorCallback,
	});
};

export const fetchCardDetailsApi = function ({ requestData, res200Callback, resCallback, resErrorCallback }) {
	apiCaller({
		apiLink: "fetch-customer-details",
		requestData,
		res200Callback,
		resCallback,
		resErrorCallback,
	});
};

export const updateContactNumberApi = function ({ requestData, res200Callback, resCallback, resErrorCallback }) {
	apiCaller({
		apiLink: "update-contact-number",
		requestData,
		res200Callback,
		resCallback,
		resErrorCallback,
	});
};

export const mergeCustomersApi = function ({ requestData, res200Callback, resCallback, resErrorCallback }) {
	apiCaller({
		apiLink: "merge-customers",
		requestData,
		res200Callback,
		resCallback,
		resErrorCallback,
	});
};

export const mergeCardsApi = function ({ requestData, res200Callback, resCallback, resErrorCallback }) {
	apiCaller({
		apiLink: "merge-cards",
		requestData,
		res200Callback,
		resCallback,
		resErrorCallback,
	});
};

export const linkCardApi = function ({ requestData, res200Callback, resCallback, resErrorCallback }) {
	apiCaller({
		apiLink: "link-card",
		requestData,
		res200Callback,
		resCallback,
		resErrorCallback,
	});
};

export const fetchPosActivityListApi = function ({ requestData, res200Callback, resCallback, resErrorCallback }) {
	apiCaller({
		apiLink: "fetch-pos-activity-list",
		requestData: { ...requestData, permission_category: ["USER_ADMINISTRATION"] },
		res200Callback,
		resCallback,
		resErrorCallback,
	});
};

export const fetchPosActivityDetailsApi = function ({ requestData, res200Callback, resCallback, resErrorCallback }) {
	apiCaller({
		apiLink: "fetch-pos-activity-details",
		requestData: { ...requestData, permission_category: ["USER_ADMINISTRATION"] },
		res200Callback,
		resCallback,
		resErrorCallback,
	});
};

export const fetchPosMemberListApi = function ({ requestData, res200Callback, resCallback, resErrorCallback }) {
	apiCaller({
		apiLink: "fetch-pos-member-list",
		requestData: { ...requestData, permission_category: ["USER_ADMINISTRATION"] },
		res200Callback,
		resCallback,
		resErrorCallback,
	});
};

export const createPosMemberApi = function ({ requestData, res200Callback, resCallback, resErrorCallback }) {
	apiCaller({
		apiLink: "create-pos-member",
		requestData: { ...requestData, permission_category: ["USER_ADMINISTRATION"] },
		res200Callback,
		resCallback,
		resErrorCallback,
	});
};

export const fetchAppVersionListApi = function ({ requestData, res200Callback, resCallback, resErrorCallback }) {
	apiCaller({
		apiLink: "app-version/fetch-app-version-list",
		requestData,
		res200Callback,
		resCallback,
		resErrorCallback,
	});
};

export const fetchAppVersionDetailsApi = function ({ requestData, res200Callback, resCallback, resErrorCallback }) {
	apiCaller({
		apiLink: "app-version/fetch-app-version-details-admin",
		requestData,
		res200Callback,
		resCallback,
		resErrorCallback,
	});
};

export const createAppVersionApi = function ({ requestData, res200Callback, resCallback, resErrorCallback }) {
	apiCaller({
		apiLink: "app-version/create-app-version",
		requestData,
		res200Callback,
		resCallback,
		resErrorCallback,
	});
};

export const updateAppVersionApi = function ({ requestData, res200Callback, resCallback, resErrorCallback }) {
	apiCaller({
		apiLink: "app-version/update-app-version",
		requestData,
		res200Callback,
		resCallback,
		resErrorCallback,
	});
};

export const deleteAppVersionApi = function ({ requestData, res200Callback, resCallback, resErrorCallback }) {
	apiCaller({
		apiLink: "app-version/delete-app-version",
		requestData,
		res200Callback,
		resCallback,
		resErrorCallback,
	});
};

export const sendLoginOTPApi = function ({ requestData, res200Callback, resCallback, resErrorCallback }) {
	apiCaller({
		apiLink: "send-verification-otp",
		requestData,
		res200Callback,
		resCallback,
		resErrorCallback,
	});
};

export const verifyOTPApi = function ({ requestData, res200Callback, resCallback, resErrorCallback }) {
	apiCaller({
		apiLink: "verify-otp",
		requestData,
		res200Callback,
		resCallback,
		resErrorCallback,
	});
};

export const fetchAllStoresApi = function ({ requestData, res200Callback, resCallback, resErrorCallback }) {
	apiCaller({
		apiLink: "store/fetch-store-list-admin",
		requestData: { ...requestData, permission_category: ["STORE_CONTROL_CENTER", "REPORTS"] },
		res200Callback,
		resCallback,
		resErrorCallback,
	});
};

export const fetchStoresListApi = function ({ requestData, res200Callback, resCallback, resErrorCallback }) {
	apiCaller({
		apiLink: "store/fetch-store-list",
		requestData: { ...requestData, permission_category: ["STORE_CONTROL_CENTER"] },
		res200Callback,
		resCallback,
		resErrorCallback,
	});
};

export const AddStoreApi = function ({ requestData, res200Callback, resCallback, resErrorCallback }) {
	apiCaller({
		bodyType: "formData",
		apiLink: "store/create-store-admin",
		requestData,
		res200Callback,
		resCallback,
		resErrorCallback,
	});
};

export const AddStoreDetailApi = function ({ requestData, res200Callback, resCallback, resErrorCallback }) {
	apiCaller({
		apiLink: "store/create-store-detail",
		requestData: { ...requestData, permission_category: ["STORE_CONTROL_CENTER"] },
		res200Callback,
		resCallback,
		resErrorCallback,
	});
};

export const updateStoreApi = function ({ requestData, res200Callback, resCallback, resErrorCallback }) {
	apiCaller({
		apiLink: "store/update-store-admin",
		requestData,
		res200Callback,
		resCallback,
		resErrorCallback,
	});
};

export const updateStoreDetailApi = function ({ requestData, res200Callback, resCallback, resErrorCallback }) {
	apiCaller({
		apiLink: "store/update-store-detail",
		requestData: { ...requestData, permission_category: ["STORE_CONTROL_CENTER"] },
		res200Callback,
		resCallback,
		resErrorCallback,
	});
};

export const fetchAdminUserTypeApi = function ({ requestData, res200Callback, resCallback, resErrorCallback }) {
	apiCaller({
		apiLink: "fetch-admin-user-type",
		requestData,
		res200Callback,
		resCallback,
		resErrorCallback,
	});
};

export const fetchFeatureListApi = function ({ requestData, res200Callback, resCallback, resErrorCallback }) {
	apiCaller({
		apiLink: "dashboard/fetch-feature-list-admin",
		requestData,
		res200Callback,
		resCallback,
		resErrorCallback,
	});
};

export const updateFeatureListApi = function ({ requestData, res200Callback, resCallback, resErrorCallback }) {
	apiCaller({
		apiLink: "dashboard/update-feature",
		requestData,
		res200Callback,
		resCallback,
		resErrorCallback,
	});
};
export const getAddress = (longitude, latitute) => {
	return axios
		.get(
			` https://revgeocode.search.hereapi.com/v1/revgeocode?at=${longitude},${latitute}&lang=en-US&apiKey=wIpVPncWIUyyxluO6KSSuK5zRr6RUPf30Tp7NzZ1Y8Q`
		)
		.then((res) => {
			return res.data.items[0].address;
		})
		.catch((error) => {
			return error;
		});
};

export const fetchSharePointsAdminDataApi = function ({ requestData, res200Callback, resCallback, resErrorCallback }) {
	apiCaller({
		apiLink: "fetch-share-points-data",
		requestData,
		res200Callback,
		resCallback,
		resErrorCallback,
	});
};

export const fetchSharePointsAdminRecentTxnsApi = function ({
	requestData,
	res200Callback,
	resCallback,
	resErrorCallback,
}) {
	apiCaller({
		apiLink: "fetch-recent-share-points-txn",
		requestData,
		res200Callback,
		resCallback,
		resErrorCallback,
	});
};
export const deleteQuestionArchive = function ({ requestData, res200Callback, resCallback, resErrorCallback }) {
	apiCaller({
		apiLink: "survey/archive-survey-question",
		requestData: { ...requestData, permission_category: ["REPORTS"] },
		res200Callback,
		resCallback,
		resErrorCallback,
	});
}; //

export const fetchCountryListApi = function ({ requestData, res200Callback, resCallback, resErrorCallback }) {
	apiCaller({
		apiLink: "fetch-country-list-admin",
		requestData,
		res200Callback,
		resCallback,
		resErrorCallback,
	});
};

export const fetchCountryConfigurationApi = function ({ requestData, res200Callback, resCallback, resErrorCallback }) {
	apiCaller({
		apiLink: "fetch-configuration",
		requestData,
		res200Callback,
		resCallback,
		resErrorCallback,
	});
};

export const fetchCountryInformationApi = function ({ requestData, res200Callback, resCallback, resErrorCallback }) {
	apiCaller({
		apiLink: "fetch-country-information",
		requestData,
		res200Callback,
		resCallback,
		resErrorCallback,
	});
};

export const updateCountryConfigurationApi = function ({ requestData, res200Callback, resCallback, resErrorCallback }) {
	apiCaller({
		apiLink: "update-configuration",
		requestData,
		res200Callback,
		resCallback,
		resErrorCallback,
	});
};

export const updateCountryInformationApi = function ({ requestData, res200Callback, resCallback, resErrorCallback }) {
	apiCaller({
		apiLink: "update-country-information",
		requestData,
		res200Callback,
		resCallback,
		resErrorCallback,
	});
};

export const updateCountryStatusApi = function ({ requestData, res200Callback, resCallback, resErrorCallback }) {
	apiCaller({
		apiLink: "update-country-status",
		requestData,
		res200Callback,
		resCallback,
		resErrorCallback,
	});
};

export const reoderpromolist = function ({ requestData, res200Callback, resCallback, resErrorCallback }) {
	apiCaller({
		apiLink: "section/reorder-promo-list",
		requestData: { ...requestData, permission_category: ["STORE_CONTROL_CENTER"] },
		res200Callback,
		resCallback,
		resErrorCallback,
	});
};

export const fetchSectionList = function ({ requestData, res200Callback, resCallback, resErrorCallback }) {
	apiCaller({
		apiLink: "section/fetch-section-list-admin",
		requestData: { ...requestData, permission_category: ["STORE_CONTROL_CENTER"] },
		res200Callback,
		resCallback,
		resErrorCallback,
	});
};

export const fetchSectionType = function ({ requestData, res200Callback, resCallback, resErrorCallback }) {
	apiCaller({
		apiLink: "section/fetch-section-types",
		requestData: { ...requestData, permission_category: ["STORE_CONTROL_CENTER"] },
		res200Callback,
		resCallback,
		resErrorCallback,
	});
};

export const reorderSectionList = function ({ requestData, res200Callback, resCallback, resErrorCallback }) {
	apiCaller({
		apiLink: "section/reorder-section-list",
		requestData: { ...requestData, permission_category: ["STORE_CONTROL_CENTER"] },
		res200Callback,
		resCallback,
		resErrorCallback,
	});
};
export const createSection = function ({ requestData, res200Callback, resCallback, resErrorCallback }) {
	apiCaller({
		apiLink: "section/create-section",
		requestData: { ...requestData, permission_category: ["STORE_CONTROL_CENTER"] },
		res200Callback,
		resCallback,
		resErrorCallback,
	});
};
export const resetErrorLog = function ({ requestData, res200Callback, resCallback, resErrorCallback }) {
	apiCaller({
		apiLink: "error-log/reset-error-logs",
		requestData,
		res200Callback,
		resCallback,
		resErrorCallback,
	});
};
export const deleteErrorLog = function ({ requestData, res200Callback, resCallback, resErrorCallback }) {
	apiCaller({
		apiLink: "error-log/delete-error-logs",
		requestData,
		res200Callback,
		resCallback,
		resErrorCallback,
	});
};
export const fetchErrorLog = function ({ requestData, res200Callback, resCallback, resErrorCallback }) {
	apiCaller({
		apiLink: "error-log/fetch-error-logs",
		requestData,
		res200Callback,
		resCallback,
		resErrorCallback,
	});
};
export const fetchInaamAdminList = function ({ requestData, res200Callback, resCallback, resErrorCallback }) {
	apiCaller({
		apiLink: "accessibility/fetch-reward-admin-list",
		requestData: { ...requestData, permission_category: ["USER_ADMINISTRATION"] },
		res200Callback,
		resCallback,
		resErrorCallback,
	});
};
export const createInaamAdmin = function ({ requestData, res200Callback, resCallback, resErrorCallback }) {
	apiCaller({
		apiLink: "accessibility/create-reward-admin",
		requestData: { ...requestData, permission_category: ["USER_ADMINISTRATION"] },
		res200Callback,
		resCallback,
		resErrorCallback,
	});
};
export const updateInaamAdmin = function ({ requestData, res200Callback, resCallback, resErrorCallback }) {
	apiCaller({
		apiLink: "accessibility/update-reward-admin",
		requestData: { ...requestData, permission_category: ["USER_ADMINISTRATION"] },
		res200Callback,
		resCallback,
		resErrorCallback,
	});
};
export const deleteInaamAdmin = function ({ requestData, res200Callback, resCallback, resErrorCallback }) {
	apiCaller({
		apiLink: "accessibility/delete-reward-admin",
		requestData: { ...requestData, permission_category: ["USER_ADMINISTRATION"] },
		res200Callback,
		resCallback,
		resErrorCallback,
	});
};
export const setAdminPermissions = function ({ requestData, res200Callback, resCallback, resErrorCallback }) {
	apiCaller({
		apiLink: "accessibility/set-admin-permissions",
		requestData: { ...requestData, permission_category: ["USER_ADMINISTRATION"] },
		res200Callback,
		resCallback,
		resErrorCallback,
	});
};
export const getAdminPermissions = function ({ requestData, res200Callback, resCallback, resErrorCallback }) {
	apiCaller({
		apiLink: "accessibility/get-admin-permissions",
		requestData: { ...requestData, permission_category: ["USER_ADMINISTRATION"] },
		res200Callback,
		resCallback,
		resErrorCallback,
	});
};
export const updateInaamAdminStatus = function ({ requestData, res200Callback, resCallback, resErrorCallback }) {
	apiCaller({
		apiLink: "accessibility/update-reward-admin-status",
		requestData: { ...requestData, permission_category: ["USER_ADMINISTRATION"] },
		res200Callback,
		resCallback,
		resErrorCallback,
	});
};


// Synchronize

export const fetchUser = function ({ requestData, res200Callback, resCallback, resErrorCallback }) {
	apiCaller({
		apiLink: "helpdesk/fetch-user",
		requestData: { ...requestData, permission_category: ["CUSTOMER_SUPPORT"] },
		res200Callback,
		resCallback,
		resErrorCallback,
	});
};
export const syncTransactionAPI = function ({ requestData, res200Callback, resCallback, resErrorCallback }) {
	apiCaller({
		apiLink: "helpdesk/sync-transactions",
		requestData: { ...requestData, permission_category: ["CUSTOMER_SUPPORT"] },
		res200Callback,
		resCallback,
		resErrorCallback,
	});
};
export const fetchTransaction = function ({ requestData, res200Callback, resCallback, resErrorCallback }) {
	apiCaller({
		apiLink: "helpdesk/fetch-transactions",
		requestData: { ...requestData, permission_category: ["CUSTOMER_SUPPORT"] },
		res200Callback,
		resCallback,
		resErrorCallback,
	});
};

export const fetchVouchers = function ({ requestData, res200Callback, resCallback, resErrorCallback }) {
	apiCaller({
		apiLink: "helpdesk/fetch-vouchers",
		requestData: { ...requestData, permission_category: ["CUSTOMER_SUPPORT"] },
		res200Callback,
		resCallback,
		resErrorCallback,
	});
};

export const addVoucher = function ({ requestData, res200Callback, resCallback, resErrorCallback }) {
	apiCaller({
		apiLink: "helpdesk/add-voucher",
		requestData: { ...requestData, permission_category: ["CUSTOMER_SUPPORT"] },
		res200Callback,
		resCallback,
		resErrorCallback,
	});
};
export const unlockCard = function ({ requestData, res200Callback, resCallback, resErrorCallback }) {
	apiCaller({
		apiLink: "helpdesk/unlock-card",
		requestData: { ...requestData, permission_category: ["CUSTOMER_SUPPORT"] },
		res200Callback,
		resCallback,
		resErrorCallback,
	});
};

export const searchCustomersSyncApi = function ({ requestData, res200Callback, resCallback, resErrorCallback }) {
	apiCaller({
		apiLink: "helpdesk/search-customer",
		requestData: { ...requestData, permission_category: ["CUSTOMER_SUPPORT"] },
		res200Callback,
		resCallback,
		resErrorCallback,
	});
};

// Multi Languages Api's

export const createLanguageApi = function ({ requestData, res200Callback, resCallback, resErrorCallback }) {
	apiCaller({
		apiLink: "multi-language/create-language",
		requestData: { ...requestData },
		res200Callback,
		resCallback,
		resErrorCallback,
	});
};

export const updateLanguageApi = function ({ requestData, res200Callback, resCallback, resErrorCallback }) {
	apiCaller({
		apiLink: "multi-language/update-language",
		requestData: { ...requestData },
		res200Callback,
		resCallback,
		resErrorCallback,
	});
};

export const createLabelApi = function ({ requestData, res200Callback, resCallback, resErrorCallback }) {
	apiCaller({
		apiLink: "multi-language/create-label",
		requestData: { ...requestData },
		res200Callback,
		resCallback,
		resErrorCallback,
	});
};

export const updateLabelApi = function ({ requestData, res200Callback, resCallback, resErrorCallback }) {
	apiCaller({
		apiLink: "multi-language/update-label",
		requestData: { ...requestData },
		res200Callback,
		resCallback,
		resErrorCallback,
	});
};

export const deleteLabelApi = function ({ requestData, res200Callback, resCallback, resErrorCallback }) {
	apiCaller({
		apiLink: "multi-language/delete-label",
		requestData: { ...requestData },
		res200Callback,
		resCallback,
		resErrorCallback,
	});
};

export const addLanguageEquivalentApi = function ({ requestData, res200Callback, resCallback, resErrorCallback }) {
	apiCaller({
		apiLink: "multi-language/add-language-equivalent",
		requestData,
		res200Callback,
		resCallback,
		resErrorCallback,
	});
};

export const updateLanguageEquivalentApi = function ({ requestData, res200Callback, resCallback, resErrorCallback }) {
	apiCaller({
		apiLink: "multi-language/update-language-equivalent",
		requestData,
		res200Callback,
		resCallback,
		resErrorCallback,
	});
};

export const deleteLanguageEquivalentApi = function ({ requestData, res200Callback, resCallback, resErrorCallback }) {
	apiCaller({
		apiLink: "multi-language/delete-language-equivalent",
		requestData,
		res200Callback,
		resCallback,
		resErrorCallback,
	});
};

export const getLanguagesApi = function ({ requestData, res200Callback, resCallback, resErrorCallback }) {
	apiCaller({
		apiLink: "multi-language/languages-admin",
		requestData: { ...requestData },
		res200Callback,
		resCallback,
		resErrorCallback,
	});
};

export const getLanguageDataApi = function ({ requestData, res200Callback, resCallback, resErrorCallback }) {
	apiCaller({
		apiLink: "multi-language/get-language-data-admin",
		requestData,
		res200Callback,
		resCallback,
		resErrorCallback,
	});
};

export const importLanguageDataApi = function ({ requestData, res200Callback, resCallback, resErrorCallback }) {
	apiCaller({
		apiLink: "multi-language/import-language-data",
		requestData: { ...requestData, permission_category: ["USER_ADMINISTRATION"] },
		res200Callback,
		resCallback,
		resErrorCallback,
	});
};

export const erafflePrevWinners = function ({ requestData, res200Callback, resCallback, resErrorCallback }) {
	apiCaller({
		apiLink: "eraffle-prev-winner",
		requestData,
		res200Callback,
		resCallback,
		resErrorCallback,
	});
};

export const eraffleFindWinner = function ({ requestData, res200Callback, resCallback, resErrorCallback }) {
	apiCaller({
		apiLink: "eraffle-find-winner",
		requestData,
		res200Callback,
		resCallback,
		resErrorCallback,
	});
};
